import { UiSection } from '../../enums';

export default {
  [UiSection.SimpleSearch]: {
    SearchButton: {
      Text: 'Search',
    },
    SearchInput: {
      Placeholder: 'Search...',
    },
  },
  [UiSection.SearchResults]: {
    ResultsTable: {
      Header: {
        ID: 'ID',
        Title: 'Title',
        Sport: 'Sport',
        League: 'League',
        Year: 'Year',
        HomeTeam: 'Home',
        AwayTeam: 'Away',
        HomeConference: 'H.Conf',
        AwayConference: 'A.Conf',
        Date: 'Date',
        VideoType: 'Video Type',
        Description: 'Description',
        Participants: 'Participants',
        ThumbNailUrl: 'Type',
        Tags: 'Tags',
        createdDate: 'Created',
        Owner: 'Owner',
        Qualifier: 'Phase',
        GameNumber: 'Game #',
      },
      Pagination: {
        Size: 'Displaying: ',
      },
      ClearFilter: 'Clear Filters',
      ApplyFilter: 'Apply Filters',
    },
    VaultButton: {
      Text: 'Vault',
    },
    SocialButton: {
      Text: 'Social',
    },
  },
  [UiSection.Header]: {
    UserSelect: {
      UseAs: 'Use as',
      LoadingText: 'Loading...',
      UnableToLoadText: 'Could not load',
      UsersNotFound: 'No users found',
      OrgPlaceholder: 'Organization',
      UserPlaceholder: 'User',
    },
  },
  [UiSection.Upload]: {
    UploadCard: {
      Title: 'Sample Video Test',
      GetTokenButton: {
        Text: 'Get Token',
      },
      SubmitButton: {
        Text: 'Execute',
      },
      UploadDetails: {
        IdLabel: 'Upload ID: ',
      },
    },
    EventsCard: {
      Title: 'Events',
      GetEventsButton: {
        Text: 'Get Events',
      },
    },
  },
};
